<template>
<div class="opportunity-menu">
	<div class="item" v-for="(item, index) in opportunityMenu" :key="index">
		<div class="item-caption" @click="toggle(item.componentName)">
			<grid flat>
				<grid-item size="33/40" class="item-title">
					{{ item.title }}
				</grid-item>
				<grid-item size="7/40" class="open-icon"
					:class="$route.hash == ('#' + item.componentName) ? 'active' : ''"
				>
					<i class="icon-down-open"></i>
				</grid-item>
			</grid>
		</div>
		<transition name="expand"
			@enter="enter"
			@leave="leave"
		>
			<div class="item-content" v-if="$route.hash == ('#' + item.componentName)">
				<component
					class="content"
					:is="item.componentName"
					v-bind="item.props"
				/>
			</div>
		</transition>
	</div>
</div>
</template>

<script>
import AboutTab from './tabs/AboutTab'
import MainDetails from './tabs/MainDetails'
import NearbyInfrastructure from './tabs/NearbyInfrastructure'
import LogisticTab from './tabs/LogisticTab'
import ResourcesTab from './tabs/ResorcesTab'
import RegionTab from './tabs/RegionTab'
import RegionalStatisticsTab from './tabs/RegionalStatisticsTab'

import OilMainDetails from './oilTabs/OilMainDetails'
import ProposedDeal from './oilTabs/ProposedDeal'
import StraitigraphyTab from './oilTabs/StraitigraphyTab'

export default {
	components: {
		AboutTab,
		MainDetails,
		NearbyInfrastructure,
		LogisticTab,
		ResourcesTab,
		RegionTab,
		RegionalStatisticsTab,
		OilMainDetails,
		ProposedDeal,
		StraitigraphyTab
	},
	props: {
		opportunity: {
			type: Object
		}
	},
	computed: {
		opportunityMenu() {
			let menu = [
				{ title: 'About', componentName: 'AboutTab' },
				{ title: 'Main Details',
					componentName: 'MainDetails',
					props: {
						'opportunity': this.opportunity
					}
				},
				{ title: 'Nearby Infrastructure',
					componentName: 'NearbyInfrastructure',
					props: {
						'opportunity': this.opportunity
					}
				},
				{ title: 'Logistics', componentName: 'LogisticTab' },
				{ title: 'Resources', componentName: 'ResourcesTab' },
				{ title: 'Region', componentName: 'RegionTab' },
				{ title: 'Regional Statistics', componentName: 'RegionalStatisticsTab' }
			]
			
			if(this.opportunity.sectorId == 29) {
				menu = [
					{ title: 'About', componentName: 'AboutTab' },
					{ title: 'Main Details', componentName: 'OilMainDetails'},
					{ title: 'Proposed Deal Structure', componentName: 'ProposedDeal'},
					{ title: 'Straitigraphy', componentName: 'StraitigraphyTab'},
					{ title: 'Resources', componentName: 'ResourcesTab' }
				]
			}
			if(this.opportunity.sectorId == 30) {
				menu = [
					{ title: 'About', componentName: 'AboutTab' },
					{ title: 'Main Details', componentName: 'OilMainDetails'}
				]
			}
		
			return menu
		}
	},
	methods: {
		toggle(tab) {
			let hash = this.$route.hash == '#' + tab ? null : '#' + tab
			this.$router.push({
				hash,
				query: {
					...this.$route.query
				}
			})
		},
		enter(element) {
			element.style.height = 'auto'
			const height = element.clientHeight + 'px'
			element.style.height = 0

			setTimeout(() => {
				element.style.height = height;
			})
		},
		leave(element) {
			const height = element.clientHeight + 'px'
			element.style.height = height;
			setTimeout(() => {
				element.style.height = 0;
			})
		}
	}
}
</script>

<style lang="scss">
.opportunity-menu {
	margin-top: 14px;
	border-bottom: 1px solid #5f8898;

	.item {
		.item-caption {
			border-top: 1px solid #5f8898;
			cursor: pointer;
			user-select: none;

			.item-title {
				font-weight: 500;
				color: #3b9fcf;
				font-size: 14px;
				text-align: left;
				padding: 11px 0px;
			}
			.open-icon {
				color: #fff;
				font-size: 12px;
				line-height: 38px;
				transition: all 0.5s ease-in-out;
			}
			.open-icon.active {
				transform: rotate(180deg);
			}
		}
		.item-content {
			overflow: hidden;
			width: 100%;
			border-top: 1px solid #5f8898;
			
			.content {
				margin: 12px 0px 17px;
				padding-right: 8px;
			}
			p {
				color: #fff;
				text-align: left;
				font-size: 12px;
				font-weight: 300;
				margin: 0;
			}
		}
	}
	.expand-enter-active,
	.expand-leave-active {
		transform: translate3d(-0.1px, -0.1px, 0);
		transition: all 0.5s ease-in-out;
	}
}
</style>
